import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { Constants } from '../../interfaces/constants';
import { UtilsService } from '../../services/utils.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from '../../../../environments/environment';

export interface FormFactoryFormField {
	name: string;
	label: {
		value: string;
		translate: boolean;
	};
	type: 'INPUT-TEXT' | 'INPUT-TEXT-LANG';
	data: any;
	validators: Validators | null;
	additionalData?: any;
}

@Component({
	selector: 'app-form-factory',
	standalone: true,
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule],
	templateUrl: './form-factory.component.html',
	styleUrl: './form-factory.component.scss',
})
export class FormFactoryComponent implements OnChanges, OnDestroy {
	private onDestroy: Subject<any> = new Subject();
  externalAssets = environment.reseller.externalAssets;
	@Input() formFields: FormFactoryFormField[] = [];
  @Input() formData: any;
	@Output() formChange: EventEmitter<any> = new EventEmitter();

	formGroup: FormGroup = new FormGroup({});

	availableLanguages = Constants.AVAILABLE_LANGUAGES;
	avaliableLanguagesCodes = Constants.AVAILABLE_LANGUAGES.map(item => item.code);

	constructor(private utils: UtilsService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['formFields']) {
			this.formInitialization();
		}
    if (changes['formData']) {
      this.formGroup.patchValue(changes['formData'].currentValue);
    }
	}

	ngOnDestroy(): void {
		this.onDestroy.next('');
	}

	private formInitialization() {
		let control: FormControl;
		let componentValue;
		this.formFields.forEach(field => {
			switch (field.type) {
				case 'INPUT-TEXT': {
					control = new FormControl(field.data, field.validators);
					this.formGroup.addControl(field.name, control);
					break;
				}
				case 'INPUT-TEXT-LANG': {
					this.avaliableLanguagesCodes.forEach(code => {
						field.additionalData = code;
						componentValue = field.data ? field.data.details?.find((detail: any) => detail.lang === code.toUpperCase()) : null;
						control = new FormControl(componentValue, field.validators);
						this.formGroup.addControl(field.name + this.utils.titleCase(code), control);
					});
					break;
				}
			}
		});

		this.formGroup.valueChanges.pipe(takeUntil(this.onDestroy)).subscribe(selectedValue => {
      this.formChange.emit(this.formGroup);
		});
	}

	formAction() {}
}
